import * as api from '../api';

//Action Creators
export const getTales = () => async (dispatch) => {
    try {
        const token = localStorage.getItem('token');
        
        if (!token) {
            return;
        }

        const { data } = await api.fetchTales();
        
        // Ensure data is an array
        const talesArray = Array.isArray(data) ? data : [];
        
        dispatch({ type: 'GET_TALES', payload: talesArray });
    } catch (error) {
        console.error('Error fetching tales:', error);
    }
};

// Public version for unauthenticated users
export const getPublicTales = () => async (dispatch) => {
    try {
        const { data } = await api.fetchTales();
        
        // Ensure data is an array
        const talesArray = Array.isArray(data) ? data : [];
        
        dispatch({ type: 'GET_TALES', payload: talesArray });
    } catch (error) {
        console.error('Error fetching public tales:', error);
    }
};

export const createTale = (tale) => async(dispatch) => {
    try{
        const {data} = await api.createTale(tale);
        dispatch({type:'CREATE', payload:data});
    }catch(error){
        // Handle error silently
    }
}

export const getTale = (id) => async (dispatch) => {
    try {
        const { data } = await api.fetchTale(id);
        
        dispatch({ type: 'GET_TALE', payload: data });
    } catch (error) {
        console.error('Error fetching tale:', error);
    }
};

export const deleteTale = (id) => async (dispatch) => {
    try {
        await api.deleteTale(id);
        
        dispatch({ type: 'DELETE_TALE', payload: id });
    } catch (error) {
        console.error('Error deleting tale:', error);
    }
};

export const updateTale = (id, updatedTale) => async (dispatch) => {
    try {
        const { data } = await api.updateTale(id, updatedTale);
        dispatch({ type: 'UPDATE_TALE', payload: data });
    } catch (error) {
        console.error('Error updating tale:', error);
    }
};

export const searchTales = (searchQuery, groupName) => async (dispatch) => {
    try {
        const params = new URLSearchParams();
        if (searchQuery) params.append('search', searchQuery);
        if (groupName) params.append('group', groupName);
        
        const { data } = await api.searchTales(params.toString());
        
        dispatch({ type: 'SEARCH_TALES', payload: data });
    } catch (error) {
        console.error('Error searching tales:', error);
    }
};

export const updateComment = (id, updatedComment) => async (dispatch) => {
    try {
        const { data } = await api.updateComment(id, updatedComment);
        
        dispatch({ 
            type: 'UPDATE_COMMENT', 
            payload: {
                ...data,
                tale: updatedComment.taleId // Make sure we have the tale ID
            }
        });
        
        return data;
    } catch (error) {
        console.error('Error updating comment:', error);
        throw error;
    }
};

export const deleteComment = (commentId, taleId) => async (dispatch) => {
    try {
        await api.deleteComment(commentId);
        
        dispatch({ 
            type: 'DELETE_COMMENT', 
            payload: { 
                commentId,
                taleId 
            }
        });
        
        return { success: true };
    } catch (error) {
        console.error('Error deleting comment:', error);
        throw error;
    }
};